import { useQuery } from 'react-query';

import { publicExportsApi } from 'src/Services/API';
import { ContactDto } from 'src/Services/API/generated';

const useFetchExportedContact = ({ token, contactId }: { token: string; contactId: string }) => {
  return useQuery({
    queryKey: ['fetch-exported-contact', token, contactId],
    queryFn: async () => {
      return (await publicExportsApi.publicExportsControllerFindEntityById(token, contactId))
        .data as unknown as ContactDto;
    },
    staleTime: 5 * 60 * 1000,
    cacheTime: 10 * 60 * 1000,
  });
};

export default useFetchExportedContact;
